import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';
import { ErrorBoundary } from 'bernie-view';

import { LocalizedText } from '@shared-ui/localization-context';

import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkSecondaryButton } from 'uitk-react-button';
import { UitkSpacing } from 'uitk-react-spacing';

import { LodgingPwaPropertySearch } from 'src/common/__generated__/api';

const ButtonTracked = ClickTracker(UitkSecondaryButton);

interface ButtonTriggerType {
  __typename: 'UIPrimaryButton';
}
type Trigger = NonNullable<LodgingPwaPropertySearch.propertySearch['pagination']>['trigger'];
export type ShowMoreButtonTrigger = Extract<Trigger, ButtonTriggerType>;
export interface ShowMoreButtonProps {
  onNextSubset: (e: Event) => void;
  isLoading: boolean;
  rfrr: string;
  linkName: string;
}

export const ShowMoreButton = ({ onNextSubset, isLoading, rfrr, linkName }: ShowMoreButtonProps) => (
  <ErrorBoundary label="hotel.search.showMoreResultsButton">
    <UitkSpacing padding={{ blockstart: 'three' }}>
      <UitkLayoutFlex justifyContent="center" tag="section">
        <ButtonTracked disabled={isLoading} data-stid="show-more-results" onClick={onNextSubset} rfrr={rfrr} linkName={linkName}>
          <LocalizedText message="hotels.searchResults.paginationButton.label" />
        </ButtonTracked>
      </UitkLayoutFlex>
    </UitkSpacing>
  </ErrorBoundary>
);
